import api from "../../utils/api";
import { setAlert } from './alert';
import {
  LOADING,
  GET_ALL_USERS_DATA,
  GET_USER_DETAILS,
  SUPER_UPDATE_USER_DETAILS,
  DELETE_USERS,
  SEARCH_USERS,
  ADD_NEW_USER,
} from "../types";

export const getAllUsersData = () => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.get('/users');
    dispatch({
      type: GET_ALL_USERS_DATA,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getUserDetails = (userId) => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.post(`/users/detail`, { userId });
    dispatch({
      type: GET_USER_DETAILS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateUserDetails = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/update-details`, data);
    dispatch({
      type: SUPER_UPDATE_USER_DETAILS,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateUserMembership = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/update-membership`, data);
    dispatch({
      type: SUPER_UPDATE_USER_DETAILS,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const deleteUsers = (data) => async (dispatch) => {
  try {
    const res = await api.post('/users/delete', data);
    dispatch({
      type: DELETE_USERS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const searchUsers = (data) => async (dispatch) => {
  try {
    const res = await api.post('/users/search', data);
    dispatch({
      type: SEARCH_USERS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateUserAvatar = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/update-avatar`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    dispatch({
      type: SUPER_UPDATE_USER_DETAILS,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const sendReqeustUpdateMembership = (data) => async (dispatch) => {
  try {
    const res = await api.post('/users/send-request-update-membership', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const createUserFromSuperadmin = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/users/create-user-from-superadmin`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    dispatch({
      type: ADD_NEW_USER,
      payload: res.data
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}
